import { SettingsManager } from "@viamap/viamap2-common";
import { VurderingsStruktur } from "./VURDTypes";

export class vurdCollector {

   /**
 * @link https://datafordeler.dk/dataoversigt/ejendomsvurdering-vur/ejendomsvurdering-bestemt-fast-ejendom/
 */
   static async vurdLookupByBfeNr(BFEnummer: string, år?: number): Promise<any> {
      if (år !== undefined) {
         return fetchVurd({ BFEnummer: BFEnummer, År: år });
      }
      return fetchVurd({ BFEnummer: BFEnummer });
   }
}

function fetchVurd(query: any): Promise<VurderingsStruktur> {
   const serviceUrl = "https://services.datafordeler.dk/Ejendomsvurdering/Ejendomsvurdering/1/rest/HentEjendomsvurderingerForBFE";
   const params = {
      username: SettingsManager.getSystemSetting("datafordelerUsername"),
      password: SettingsManager.getSystemSetting("datafordelerPassword"),
      ...query
   }
   return fetch(serviceUrl + `?${new URLSearchParams(params)}`, {
      method: 'GET',
      headers: {
         'Accept': 'application/json'
      }
   }).then(async res => {
      if (!res.ok) {
         await res.text().then(text => {
            console.error("Error response from VURD:", text);
         });
         throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json() as Promise<VurderingsStruktur>;
   });
}